import { render, staticRenderFns } from "./MeasuringUnitTranslationsDialog.vue?vue&type=template&id=729c8838"
import script from "./MeasuringUnitTranslationsDialog.vue?vue&type=script&lang=ts"
export * from "./MeasuringUnitTranslationsDialog.vue?vue&type=script&lang=ts"
import style0 from "./MeasuringUnitTranslationsDialog.vue?vue&type=style&index=0&id=729c8838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports